import { usePortalTicketsImpersonation } from "@/contexts/PortalTicketsImpersonationContext";
import { VerComoPersonasSelector } from "@/components/admin/VerComoPersonasSelector";

/**
 * "Ver como" del Portal Tickets: por persona (regla de Eduardo, 2026-10-27). Solo quien entra al
 * portal, en bloques por rol; se guarda su auth_user_id (para «Mis tickets») y el rol con el que
 * entra (para su menú).
 */
export function PortalTicketsImpersonationSelector({ className }: { className?: string } = {}) {
  const { impersonatedUser, setImpersonatedUser, clearImpersonation } = usePortalTicketsImpersonation();
  return (
    <VerComoPersonasSelector
      rutas={["/admin/portal-tickets/%"]}
      seleccionadoEmail={impersonatedUser?.email ?? null}
      seleccionadoNombre={impersonatedUser?.nombre}
      onElegir={(p) =>
        setImpersonatedUser({
          id: p.authUserId,
          nombre: p.nombre,
          email: p.email,
          rol_nombre: p.rolAccesoNombre,
          rol_id: p.rolAccesoId,
          persona_id: p.personaId,
        })
      }
      onLimpiar={clearImpersonation}
      className={className}
    />
  );
}
